import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ReportProfilePic from "../ReportButtons/ReportProfilePic";

import TgUserInput from "./StatueFormItems/TgUserInput";

import { AuthContext } from "../../../context/App-Context";
import UserProfilePostsContainer from "./UserPostItems/UserProfilePostsContainer";
import TgUserInputtgridfungo from "./StatueFormItems/TgUserInputtgridfungo";

const AngelTempleGridStatue = () => {
  const auth = useContext(AuthContext);
  const { UsernameUserID } = useParams();

  const [data, setData] = useState(null);
  //console.log(auth);

  useEffect(() => {
    // if (UsernameUserID === auth.loginVar) {
    const fetchData = async () => {
      try {
        //setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/getUserByParameters/${auth.loginVar}`
        ); // Example API endpoint

        // console.log("response data vvv ");
        // console.log(response.data.data);
        // console.log("response data vvv [0]");
        // console.log(response.data.data[0]);
        // console.log(response.data.data[0].username);
        setData(response.data.data);
      } catch (err) {
        // setError(err.message);
      } finally {
        // setLoading(false);
      }
    };
    fetchData();
    //console.log(auth);
    // }
  }, [auth.loginVar]);

  if (process.env.REACT_APP_BACKEND_URL === `http://localhost:5000/api`) {
    // console.log(auth);
    //console.log(auth.loginVar);
  }

  ///////// get profile picture

  const [profilePicUrl, setProfilePicUrl] = useState(null);

  useEffect(() => {
    //if (!data) return;

    // console.log("hook data pro pic vvv ");

    // console.log(data);
    // console.log(data[0].username);
    // console.log(data[0].email);

    const fetchProfilePic = async () => {
      try {
        // Use your auth to get current user's email/username
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/getProfilePic?email=${data[0].email}&username=${data[0].username}`
          // Add auth header if needed: { headers: { Authorization: `Bearer ${auth.token}` } }
        );

        //console.log(response.data.imageUrl);

        setProfilePicUrl(response.data.imageUrl); // This is the temporary signed URL

        // console.log(response.data.imageUrl);
      } catch (error) {
        //console.error("Error fetching profile pic:", error);
        // Optional: set a placeholder image
      }
    };

    fetchProfilePic();
  }, [data, auth.isLoggedIn]);

  /////////////////

  ///////////////////////
  /////////////////////////

  /////// post a post

  //////////////

  return (
    <div className="templegrid">
      <div className="templegrid-courtyard-setting"></div>
      {auth.isLoggedIn && (
        <div>
          {/* <div className="testamentArk1John15-TempleGridGemStone">
          powered by{" "}
          <h3 style={{ paddingLeft: "2rem", margin: ".2rem" }}>TempleGrid</h3>{" "}
        </div> */}
          <div className="testamentArk1John15-templeCatwalk">
            <div className="testamentArk1John15-templeCatwalk">
              {auth.isLoggedIn && (
                <div>
                  {profilePicUrl && <img src={profilePicUrl} alt="Profile" />}
                  <br />
                  {/* 🌟 NEW: Followers and Following titles in white */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "24px",
                      color: "white",
                      fontWeight: "bold",
                      marginBottom: "15px",
                      fontSize: "0.9rem",
                      letterSpacing: "1px",
                    }}
                  >
                    <span style={{ cursor: "pointer" }}>0 Followers</span>
                    <span style={{ cursor: "pointer" }}>0 Following</span>
                  </div>
                </div>
              )}
              {/* <div>Follow / Unfollow </div> */}
              {auth.isLoggedIn && (
                <div className="background white border radius">
                  <div className="testamentArk1John15-libraryScribe">
                    {data && (
                      <div>
                        {/* {data.profilePic} */}
                        <div>@{data[0].username}</div>
                        {/* <div>{data.bio}</div> */}
                        {/* <div>{data.userTitle}</div> */}
                      </div>
                    )}
                    {data && (
                      <button>
                        <ReportProfilePic
                          username={data[0].username}
                          email={data[0].email}
                        />
                      </button>
                    )}
                  </div>
                  {/* <div className="testamentArk1John15-libraryScribe">CEO Zeus</div> */}
                </div>
              )}
              {/* <TgUserInput /> */}
              {auth.isLoggedIn && <TgUserInputtgridfungo />}
              <div className="aquariam">
                {/* <button onClick={handleGridClick} className="aquariam-button">
                Grid
              </button>
              <button
                onClick={handleConstantineClick}
                className="aquariam-button"
              >
                Ocancerz
              </button> */}
                {/* <button className="aquariam-button">Subjects</button> */}
                {auth.isLoggedIn && (
                  <div>
                    <button className="aquariam-button">
                      <Link to="/TempleGrid/Profile">Settings</Link>
                    </button>
                    <button className="aquariam-button">
                      <Link to={`/TempleGrid/photoVault/${auth.loginVar}`}>
                        photo vault
                      </Link>
                    </button>
                    <button className="aquariam-button">
                      <Link to={`/TempleGrid/flex`}>flex</Link>
                    </button>
                    <button className="aquariam-button">
                      <Link to={`/Ocancerz`}>Ocancerz</Link>
                    </button>
                  </div>
                )}
                {/* <button className="aquariam-button">
                <Link to="/TempleGrid/photoVault">Vault</Link>
              </button> */}
                {/* ( Grid subjects ) */}
              </div>
              <div className="gridStone">
                <div className="profilePosts">
                  {auth.isLoggedIn && <UserProfilePostsContainer />}
                  {/* <div className="profilePosts_tg">
                  <div>report</div> <PostDropDown />
                  <br />
                  {data && <div>@{data[0].username}</div>} post writing
                  <div>like</div> <div>comment</div>
                  <div>* if usernameZues , delete *</div>
                  <div> date of Post : 12:00 </div>
                  <div>
                    <svg
                      width="24px"
                      height="24px"
                      stroke-width="1.5"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      color="#000000"
                    >
                      <path
                        d="M2 19V9C2 7.89543 2.89543 7 4 7H4.5C5.12951 7 5.72229 6.70361 6.1 6.2L8.32 3.24C8.43331 3.08892 8.61115 3 8.8 3H15.2C15.3889 3 15.5667 3.08892 15.68 3.24L17.9 6.2C18.2777 6.70361 18.8705 7 19.5 7H20C21.1046 7 22 7.89543 22 9V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19Z"
                        stroke="#000000"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
                        stroke="#000000"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AngelTempleGridStatue;
